// WHAT THE CERTIFICATE PAGE MAY SAY (Randall 2026-09-30). The page told every earned-but-unissued
// fitter his credential was "queued for review" -- including fitters with no certificate record at
// all, when nothing is queued until an admin queues it. Each state now says only what is true of it:
//
//   earned   every chapter + a passed final, and NO certificate record yet (nothing is queued);
//   queued   an admin has created the record (POST /admin/certification/queue), not yet approved;
//   issued   approved: the record carries issued_at and is valid;
//   revoked  issued, then revoked -- never shown as a live credential.
//
// Read from GET /certification/eligibility: `certificate` is the record or null, and
// `certificate_status` is the server's cert_status() for an issued record.
export function certificateState(elig) {
  const cert = elig && elig.certificate;
  const number = cert && cert.certificate_number;
  if (!cert) {
    return {
      key: "earned",
      title: "Certification Earned",
      statusLabel: "Not yet queued",
      message:
        "You have earned the credential: every chapter is complete and the final exam is passed. " +
        "Your certificate has not been queued for approval yet. Henry-Griffitts queues and approves " +
        "each certificate itself, and confirms the name to be engraved, before it is issued. It is " +
        "never issued automatically, and you will be emailed when it is.",
    };
  }
  if (!cert.issued_at) {
    return {
      key: "queued",
      title: "Certification Earned",
      statusLabel: "Awaiting approval",
      message:
        `Your certificate${number ? ` (${number})` : ""} has been queued and is awaiting approval by ` +
        "Henry-Griffitts." +
        (cert.name_confirmed
          ? ""
          : " The name to be engraved on it has not been confirmed yet; Henry-Griffitts confirms it with you before issuing.") +
        " You will be emailed when it is issued.",
    };
  }
  if (elig.certificate_status === "revoked") {
    return {
      key: "revoked",
      title: "Certificate Revoked",
      statusLabel: "Revoked",
      message:
        `Your certificate${number ? ` ${number}` : ""} has been revoked, so you do not hold a ` +
        "credential at the moment. Henry-Griffitts can tell you why.",
    };
  }
  return {
    key: "issued",
    title: cert.level_display || "Certified Fitter",
    statusLabel: elig.certificate_status || "valid",
    message: "",
  };
}
